// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/connector/v2/ticket.proto" (package "c1.connector.v2", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { Resource } from "./resource";
import { Timestamp } from "../../../google/protobuf/timestamp";
import { FloatValue } from "../../../google/protobuf/wrappers";
import { Any } from "../../../google/protobuf/any";
/**
 * @generated from protobuf message c1.connector.v2.TicketSchema
 */
export interface TicketSchema {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketType types = 3
     */
    types: TicketType[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketStatus statuses = 4
     */
    statuses: TicketStatus[];
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.TicketCustomField> custom_fields = 5
     */
    customFields: {
        [key: string]: TicketCustomField;
    };
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 6
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomField
 */
export interface TicketCustomField {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: bool required = 3
     */
    required: boolean;
    /**
     * @generated from protobuf oneof: value
     */
    value: {
        oneofKind: "stringValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldStringValue string_value = 100
         */
        stringValue: TicketCustomFieldStringValue;
    } | {
        oneofKind: "stringValues";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldStringValues string_values = 101
         */
        stringValues: TicketCustomFieldStringValues;
    } | {
        oneofKind: "boolValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldBoolValue bool_value = 102
         */
        boolValue: TicketCustomFieldBoolValue;
    } | {
        oneofKind: "timestampValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldTimestampValue timestamp_value = 103
         */
        timestampValue: TicketCustomFieldTimestampValue;
    } | {
        oneofKind: "pickStringValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickStringValue pick_string_value = 104
         */
        pickStringValue: TicketCustomFieldPickStringValue;
    } | {
        oneofKind: "pickMultipleStringValues";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickMultipleStringValues pick_multiple_string_values = 105
         */
        pickMultipleStringValues: TicketCustomFieldPickMultipleStringValues;
    } | {
        oneofKind: "pickObjectValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickObjectValue pick_object_value = 106
         */
        pickObjectValue: TicketCustomFieldPickObjectValue;
    } | {
        oneofKind: "pickMultipleObjectValues";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldPickMultipleObjectValues pick_multiple_object_values = 107
         */
        pickMultipleObjectValues: TicketCustomFieldPickMultipleObjectValues;
    } | {
        oneofKind: "numberValue";
        /**
         * @generated from protobuf field: c1.connector.v2.TicketCustomFieldNumberValue number_value = 108
         */
        numberValue: TicketCustomFieldNumberValue;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 4
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldStringValue
 */
export interface TicketCustomFieldStringValue {
    /**
     * @generated from protobuf field: string value = 1
     */
    value: string;
    /**
     * @generated from protobuf field: string default_value = 2
     */
    defaultValue: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldStringValues
 */
export interface TicketCustomFieldStringValues {
    /**
     * @generated from protobuf field: repeated string values = 1
     */
    values: string[];
    /**
     * @generated from protobuf field: repeated string default_values = 2
     */
    defaultValues: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldBoolValue
 */
export interface TicketCustomFieldBoolValue {
    /**
     * @generated from protobuf field: bool value = 1
     */
    value: boolean;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldNumberValue
 */
export interface TicketCustomFieldNumberValue {
    /**
     * @generated from protobuf field: google.protobuf.FloatValue value = 1
     */
    value?: FloatValue;
    /**
     * @generated from protobuf field: google.protobuf.FloatValue default_value = 2
     */
    defaultValue?: FloatValue;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldTimestampValue
 */
export interface TicketCustomFieldTimestampValue {
    /**
     * @generated from protobuf field: google.protobuf.Timestamp value = 1
     */
    value?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp default_value = 2
     */
    defaultValue?: Timestamp;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickStringValue
 */
export interface TicketCustomFieldPickStringValue {
    /**
     * @generated from protobuf field: string value = 1
     */
    value: string;
    /**
     * @generated from protobuf field: repeated string allowed_values = 2
     */
    allowedValues: string[];
    /**
     * @generated from protobuf field: string default_value = 3
     */
    defaultValue: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickMultipleStringValues
 */
export interface TicketCustomFieldPickMultipleStringValues {
    /**
     * @generated from protobuf field: repeated string values = 1
     */
    values: string[];
    /**
     * @generated from protobuf field: repeated string allowed_values = 2
     */
    allowedValues: string[];
    /**
     * @generated from protobuf field: repeated string default_values = 3
     */
    defaultValues: string[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickObjectValue
 */
export interface TicketCustomFieldPickObjectValue {
    /**
     * @generated from protobuf field: c1.connector.v2.TicketCustomFieldObjectValue value = 1
     */
    value?: TicketCustomFieldObjectValue;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values = 2
     */
    allowedValues: TicketCustomFieldObjectValue[];
    /**
     * @generated from protobuf field: c1.connector.v2.TicketCustomFieldObjectValue default_value = 3
     */
    defaultValue?: TicketCustomFieldObjectValue;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldPickMultipleObjectValues
 */
export interface TicketCustomFieldPickMultipleObjectValues {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue values = 1
     */
    values: TicketCustomFieldObjectValue[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values = 2
     */
    allowedValues: TicketCustomFieldObjectValue[];
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketCustomFieldObjectValue default_values = 3
     */
    defaultValues: TicketCustomFieldObjectValue[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketCustomFieldObjectValue
 */
export interface TicketCustomFieldObjectValue {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketStatus
 */
export interface TicketStatus {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaRequest
 */
export interface TicketsServiceGetTicketSchemaRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaResponse
 */
export interface TicketsServiceGetTicketSchemaResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema schema = 1
     */
    schema?: TicketSchema;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceListTicketSchemasRequest
 */
export interface TicketsServiceListTicketSchemasRequest {
    /**
     * @generated from protobuf field: uint32 page_size = 1
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2
     */
    pageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceListTicketSchemasResponse
 */
export interface TicketsServiceListTicketSchemasResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketSchema list = 1
     */
    list: TicketSchema[];
    /**
     * @generated from protobuf field: string next_page_token = 2
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 3
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.Ticket
 */
export interface Ticket {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3
     */
    description: string;
    /**
     * @generated from protobuf field: repeated c1.connector.v2.Resource assignees = 4
     */
    assignees: Resource[];
    /**
     * @generated from protobuf field: c1.connector.v2.Resource reporter = 5
     */
    reporter?: Resource;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketStatus status = 7
     */
    status?: TicketStatus;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketType type = 8
     */
    type?: TicketType;
    /**
     * @generated from protobuf field: repeated string labels = 9
     */
    labels: string[];
    /**
     * @generated from protobuf field: string url = 10
     */
    url: string;
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.TicketCustomField> custom_fields = 11
     */
    customFields: {
        [key: string]: TicketCustomField;
    };
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 12
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 13
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp completed_at = 14
     */
    completedAt?: Timestamp;
    /**
     * @generated from protobuf field: c1.connector.v2.Resource requested_for = 15
     */
    requestedFor?: Resource;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketType
 */
export interface TicketType {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: string display_name = 2
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketRequest
 */
export interface TicketRequest {
    /**
     * @generated from protobuf field: string display_name = 1
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 2
     */
    description: string;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketStatus status = 3
     */
    status?: TicketStatus;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketType type = 4
     */
    type?: TicketType;
    /**
     * @generated from protobuf field: repeated string labels = 5
     */
    labels: string[];
    /**
     * @generated from protobuf field: map<string, c1.connector.v2.TicketCustomField> custom_fields = 6
     */
    customFields: {
        [key: string]: TicketCustomField;
    };
    /**
     * @generated from protobuf field: c1.connector.v2.Resource requested_for = 7
     */
    requestedFor?: Resource;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceCreateTicketRequest
 */
export interface TicketsServiceCreateTicketRequest {
    /**
     * @generated from protobuf field: c1.connector.v2.TicketRequest request = 1
     */
    request?: TicketRequest;
    /**
     * @generated from protobuf field: c1.connector.v2.TicketSchema schema = 2
     */
    schema?: TicketSchema;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 8
     */
    annotations: Any[];
}
/**
 * TODO(lauren) maybe the error should be a separate proto so we can store retryable error
 *
 * @generated from protobuf message c1.connector.v2.TicketsServiceCreateTicketResponse
 */
export interface TicketsServiceCreateTicketResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Ticket ticket = 1
     */
    ticket?: Ticket;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string error = 3
     */
    error: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketRequest
 */
export interface TicketsServiceGetTicketRequest {
    /**
     * @generated from protobuf field: string id = 1
     */
    id: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceGetTicketResponse
 */
export interface TicketsServiceGetTicketResponse {
    /**
     * @generated from protobuf field: c1.connector.v2.Ticket ticket = 1
     */
    ticket?: Ticket;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any annotations = 2
     */
    annotations: Any[];
    /**
     * @generated from protobuf field: string error = 3
     */
    error: string;
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsRequest
 */
export interface TicketsServiceBulkCreateTicketsRequest {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceCreateTicketRequest ticket_requests = 1
     */
    ticketRequests: TicketsServiceCreateTicketRequest[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsResponse
 */
export interface TicketsServiceBulkCreateTicketsResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceCreateTicketResponse tickets = 1
     */
    tickets: TicketsServiceCreateTicketResponse[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsRequest
 */
export interface TicketsServiceBulkGetTicketsRequest {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceGetTicketRequest ticket_requests = 1
     */
    ticketRequests: TicketsServiceGetTicketRequest[];
}
/**
 * @generated from protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsResponse
 */
export interface TicketsServiceBulkGetTicketsResponse {
    /**
     * @generated from protobuf field: repeated c1.connector.v2.TicketsServiceGetTicketResponse tickets = 1
     */
    tickets: TicketsServiceGetTicketResponse[];
}
// @generated message type with reflection information, may provide speed optimized methods
class TicketSchema$Type extends MessageType<TicketSchema> {
    constructor() {
        super("c1.connector.v2.TicketSchema", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "types", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketType },
            { no: 4, name: "statuses", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketStatus },
            { no: 5, name: "custom_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TicketCustomField } },
            { no: 6, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketSchema>): TicketSchema {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.types = [];
        message.statuses = [];
        message.customFields = {};
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketSchema>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketSchema): TicketSchema {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* repeated c1.connector.v2.TicketType types */ 3:
                    message.types.push(TicketType.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.connector.v2.TicketStatus statuses */ 4:
                    message.statuses.push(TicketStatus.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* map<string, c1.connector.v2.TicketCustomField> custom_fields */ 5:
                    this.binaryReadMap5(message.customFields, reader, options);
                    break;
                case /* repeated google.protobuf.Any annotations */ 6:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap5(map: TicketSchema["customFields"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TicketSchema["customFields"] | undefined, val: TicketSchema["customFields"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TicketCustomField.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.connector.v2.TicketSchema.custom_fields");
            }
        }
        map[key ?? ""] = val ?? TicketCustomField.create();
    }
    internalBinaryWrite(message: TicketSchema, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* repeated c1.connector.v2.TicketType types = 3; */
        for (let i = 0; i < message.types.length; i++)
            TicketType.internalBinaryWrite(message.types[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.TicketStatus statuses = 4; */
        for (let i = 0; i < message.statuses.length; i++)
            TicketStatus.internalBinaryWrite(message.statuses[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* map<string, c1.connector.v2.TicketCustomField> custom_fields = 5; */
        for (let k of globalThis.Object.keys(message.customFields)) {
            writer.tag(5, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TicketCustomField.internalBinaryWrite(message.customFields[k], writer, options);
            writer.join().join();
        }
        /* repeated google.protobuf.Any annotations = 6; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(6, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketSchema
 */
export const TicketSchema = new TicketSchema$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomField$Type extends MessageType<TicketCustomField> {
    constructor() {
        super("c1.connector.v2.TicketCustomField", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "required", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 100, name: "string_value", kind: "message", oneof: "value", T: () => TicketCustomFieldStringValue },
            { no: 101, name: "string_values", kind: "message", oneof: "value", T: () => TicketCustomFieldStringValues },
            { no: 102, name: "bool_value", kind: "message", oneof: "value", T: () => TicketCustomFieldBoolValue },
            { no: 103, name: "timestamp_value", kind: "message", oneof: "value", T: () => TicketCustomFieldTimestampValue },
            { no: 104, name: "pick_string_value", kind: "message", oneof: "value", T: () => TicketCustomFieldPickStringValue },
            { no: 105, name: "pick_multiple_string_values", kind: "message", oneof: "value", T: () => TicketCustomFieldPickMultipleStringValues },
            { no: 106, name: "pick_object_value", kind: "message", oneof: "value", T: () => TicketCustomFieldPickObjectValue },
            { no: 107, name: "pick_multiple_object_values", kind: "message", oneof: "value", T: () => TicketCustomFieldPickMultipleObjectValues },
            { no: 108, name: "number_value", kind: "message", oneof: "value", T: () => TicketCustomFieldNumberValue },
            { no: 4, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketCustomField>): TicketCustomField {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.required = false;
        message.value = { oneofKind: undefined };
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketCustomField>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomField): TicketCustomField {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* bool required */ 3:
                    message.required = reader.bool();
                    break;
                case /* c1.connector.v2.TicketCustomFieldStringValue string_value */ 100:
                    message.value = {
                        oneofKind: "stringValue",
                        stringValue: TicketCustomFieldStringValue.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).stringValue)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldStringValues string_values */ 101:
                    message.value = {
                        oneofKind: "stringValues",
                        stringValues: TicketCustomFieldStringValues.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).stringValues)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldBoolValue bool_value */ 102:
                    message.value = {
                        oneofKind: "boolValue",
                        boolValue: TicketCustomFieldBoolValue.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).boolValue)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldTimestampValue timestamp_value */ 103:
                    message.value = {
                        oneofKind: "timestampValue",
                        timestampValue: TicketCustomFieldTimestampValue.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).timestampValue)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldPickStringValue pick_string_value */ 104:
                    message.value = {
                        oneofKind: "pickStringValue",
                        pickStringValue: TicketCustomFieldPickStringValue.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).pickStringValue)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldPickMultipleStringValues pick_multiple_string_values */ 105:
                    message.value = {
                        oneofKind: "pickMultipleStringValues",
                        pickMultipleStringValues: TicketCustomFieldPickMultipleStringValues.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).pickMultipleStringValues)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldPickObjectValue pick_object_value */ 106:
                    message.value = {
                        oneofKind: "pickObjectValue",
                        pickObjectValue: TicketCustomFieldPickObjectValue.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).pickObjectValue)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldPickMultipleObjectValues pick_multiple_object_values */ 107:
                    message.value = {
                        oneofKind: "pickMultipleObjectValues",
                        pickMultipleObjectValues: TicketCustomFieldPickMultipleObjectValues.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).pickMultipleObjectValues)
                    };
                    break;
                case /* c1.connector.v2.TicketCustomFieldNumberValue number_value */ 108:
                    message.value = {
                        oneofKind: "numberValue",
                        numberValue: TicketCustomFieldNumberValue.internalBinaryRead(reader, reader.uint32(), options, (message.value as any).numberValue)
                    };
                    break;
                case /* repeated google.protobuf.Any annotations */ 4:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomField, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* bool required = 3; */
        if (message.required !== false)
            writer.tag(3, WireType.Varint).bool(message.required);
        /* repeated google.protobuf.Any annotations = 4; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldStringValue string_value = 100; */
        if (message.value.oneofKind === "stringValue")
            TicketCustomFieldStringValue.internalBinaryWrite(message.value.stringValue, writer.tag(100, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldStringValues string_values = 101; */
        if (message.value.oneofKind === "stringValues")
            TicketCustomFieldStringValues.internalBinaryWrite(message.value.stringValues, writer.tag(101, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldBoolValue bool_value = 102; */
        if (message.value.oneofKind === "boolValue")
            TicketCustomFieldBoolValue.internalBinaryWrite(message.value.boolValue, writer.tag(102, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldTimestampValue timestamp_value = 103; */
        if (message.value.oneofKind === "timestampValue")
            TicketCustomFieldTimestampValue.internalBinaryWrite(message.value.timestampValue, writer.tag(103, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldPickStringValue pick_string_value = 104; */
        if (message.value.oneofKind === "pickStringValue")
            TicketCustomFieldPickStringValue.internalBinaryWrite(message.value.pickStringValue, writer.tag(104, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldPickMultipleStringValues pick_multiple_string_values = 105; */
        if (message.value.oneofKind === "pickMultipleStringValues")
            TicketCustomFieldPickMultipleStringValues.internalBinaryWrite(message.value.pickMultipleStringValues, writer.tag(105, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldPickObjectValue pick_object_value = 106; */
        if (message.value.oneofKind === "pickObjectValue")
            TicketCustomFieldPickObjectValue.internalBinaryWrite(message.value.pickObjectValue, writer.tag(106, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldPickMultipleObjectValues pick_multiple_object_values = 107; */
        if (message.value.oneofKind === "pickMultipleObjectValues")
            TicketCustomFieldPickMultipleObjectValues.internalBinaryWrite(message.value.pickMultipleObjectValues, writer.tag(107, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldNumberValue number_value = 108; */
        if (message.value.oneofKind === "numberValue")
            TicketCustomFieldNumberValue.internalBinaryWrite(message.value.numberValue, writer.tag(108, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomField
 */
export const TicketCustomField = new TicketCustomField$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldStringValue$Type extends MessageType<TicketCustomFieldStringValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldStringValue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "default_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldStringValue>): TicketCustomFieldStringValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        message.defaultValue = "";
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldStringValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldStringValue): TicketCustomFieldStringValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* string default_value */ 2:
                    message.defaultValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldStringValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* string default_value = 2; */
        if (message.defaultValue !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldStringValue
 */
export const TicketCustomFieldStringValue = new TicketCustomFieldStringValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldStringValues$Type extends MessageType<TicketCustomFieldStringValues> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldStringValues", [
            { no: 1, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "default_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldStringValues>): TicketCustomFieldStringValues {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        message.defaultValues = [];
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldStringValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldStringValues): TicketCustomFieldStringValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string values */ 1:
                    message.values.push(reader.string());
                    break;
                case /* repeated string default_values */ 2:
                    message.defaultValues.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldStringValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string values = 1; */
        for (let i = 0; i < message.values.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.values[i]);
        /* repeated string default_values = 2; */
        for (let i = 0; i < message.defaultValues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.defaultValues[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldStringValues
 */
export const TicketCustomFieldStringValues = new TicketCustomFieldStringValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldBoolValue$Type extends MessageType<TicketCustomFieldBoolValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldBoolValue", [
            { no: 1, name: "value", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldBoolValue>): TicketCustomFieldBoolValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = false;
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldBoolValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldBoolValue): TicketCustomFieldBoolValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bool value */ 1:
                    message.value = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldBoolValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* bool value = 1; */
        if (message.value !== false)
            writer.tag(1, WireType.Varint).bool(message.value);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldBoolValue
 */
export const TicketCustomFieldBoolValue = new TicketCustomFieldBoolValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldNumberValue$Type extends MessageType<TicketCustomFieldNumberValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldNumberValue", [
            { no: 1, name: "value", kind: "message", T: () => FloatValue },
            { no: 2, name: "default_value", kind: "message", T: () => FloatValue }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldNumberValue>): TicketCustomFieldNumberValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldNumberValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldNumberValue): TicketCustomFieldNumberValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.FloatValue value */ 1:
                    message.value = FloatValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* google.protobuf.FloatValue default_value */ 2:
                    message.defaultValue = FloatValue.internalBinaryRead(reader, reader.uint32(), options, message.defaultValue);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldNumberValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.FloatValue value = 1; */
        if (message.value)
            FloatValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.FloatValue default_value = 2; */
        if (message.defaultValue)
            FloatValue.internalBinaryWrite(message.defaultValue, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldNumberValue
 */
export const TicketCustomFieldNumberValue = new TicketCustomFieldNumberValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldTimestampValue$Type extends MessageType<TicketCustomFieldTimestampValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldTimestampValue", [
            { no: 1, name: "value", kind: "message", T: () => Timestamp },
            { no: 2, name: "default_value", kind: "message", T: () => Timestamp }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldTimestampValue>): TicketCustomFieldTimestampValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldTimestampValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldTimestampValue): TicketCustomFieldTimestampValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* google.protobuf.Timestamp value */ 1:
                    message.value = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* google.protobuf.Timestamp default_value */ 2:
                    message.defaultValue = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.defaultValue);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldTimestampValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* google.protobuf.Timestamp value = 1; */
        if (message.value)
            Timestamp.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp default_value = 2; */
        if (message.defaultValue)
            Timestamp.internalBinaryWrite(message.defaultValue, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldTimestampValue
 */
export const TicketCustomFieldTimestampValue = new TicketCustomFieldTimestampValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickStringValue$Type extends MessageType<TicketCustomFieldPickStringValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickStringValue", [
            { no: 1, name: "value", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "allowed_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_value", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldPickStringValue>): TicketCustomFieldPickStringValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.value = "";
        message.allowedValues = [];
        message.defaultValue = "";
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldPickStringValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldPickStringValue): TicketCustomFieldPickStringValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string value */ 1:
                    message.value = reader.string();
                    break;
                case /* repeated string allowed_values */ 2:
                    message.allowedValues.push(reader.string());
                    break;
                case /* string default_value */ 3:
                    message.defaultValue = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldPickStringValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string value = 1; */
        if (message.value !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.value);
        /* repeated string allowed_values = 2; */
        for (let i = 0; i < message.allowedValues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.allowedValues[i]);
        /* string default_value = 3; */
        if (message.defaultValue !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.defaultValue);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickStringValue
 */
export const TicketCustomFieldPickStringValue = new TicketCustomFieldPickStringValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickMultipleStringValues$Type extends MessageType<TicketCustomFieldPickMultipleStringValues> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickMultipleStringValues", [
            { no: 1, name: "values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "allowed_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "default_values", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldPickMultipleStringValues>): TicketCustomFieldPickMultipleStringValues {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        message.allowedValues = [];
        message.defaultValues = [];
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldPickMultipleStringValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldPickMultipleStringValues): TicketCustomFieldPickMultipleStringValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated string values */ 1:
                    message.values.push(reader.string());
                    break;
                case /* repeated string allowed_values */ 2:
                    message.allowedValues.push(reader.string());
                    break;
                case /* repeated string default_values */ 3:
                    message.defaultValues.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldPickMultipleStringValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated string values = 1; */
        for (let i = 0; i < message.values.length; i++)
            writer.tag(1, WireType.LengthDelimited).string(message.values[i]);
        /* repeated string allowed_values = 2; */
        for (let i = 0; i < message.allowedValues.length; i++)
            writer.tag(2, WireType.LengthDelimited).string(message.allowedValues[i]);
        /* repeated string default_values = 3; */
        for (let i = 0; i < message.defaultValues.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.defaultValues[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickMultipleStringValues
 */
export const TicketCustomFieldPickMultipleStringValues = new TicketCustomFieldPickMultipleStringValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickObjectValue$Type extends MessageType<TicketCustomFieldPickObjectValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickObjectValue", [
            { no: 1, name: "value", kind: "message", T: () => TicketCustomFieldObjectValue },
            { no: 2, name: "allowed_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue },
            { no: 3, name: "default_value", kind: "message", T: () => TicketCustomFieldObjectValue }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldPickObjectValue>): TicketCustomFieldPickObjectValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.allowedValues = [];
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldPickObjectValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldPickObjectValue): TicketCustomFieldPickObjectValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.TicketCustomFieldObjectValue value */ 1:
                    message.value = TicketCustomFieldObjectValue.internalBinaryRead(reader, reader.uint32(), options, message.value);
                    break;
                case /* repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values */ 2:
                    message.allowedValues.push(TicketCustomFieldObjectValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.connector.v2.TicketCustomFieldObjectValue default_value */ 3:
                    message.defaultValue = TicketCustomFieldObjectValue.internalBinaryRead(reader, reader.uint32(), options, message.defaultValue);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldPickObjectValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.TicketCustomFieldObjectValue value = 1; */
        if (message.value)
            TicketCustomFieldObjectValue.internalBinaryWrite(message.value, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values = 2; */
        for (let i = 0; i < message.allowedValues.length; i++)
            TicketCustomFieldObjectValue.internalBinaryWrite(message.allowedValues[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketCustomFieldObjectValue default_value = 3; */
        if (message.defaultValue)
            TicketCustomFieldObjectValue.internalBinaryWrite(message.defaultValue, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickObjectValue
 */
export const TicketCustomFieldPickObjectValue = new TicketCustomFieldPickObjectValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldPickMultipleObjectValues$Type extends MessageType<TicketCustomFieldPickMultipleObjectValues> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldPickMultipleObjectValues", [
            { no: 1, name: "values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue },
            { no: 2, name: "allowed_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue },
            { no: 3, name: "default_values", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketCustomFieldObjectValue }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldPickMultipleObjectValues>): TicketCustomFieldPickMultipleObjectValues {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.values = [];
        message.allowedValues = [];
        message.defaultValues = [];
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldPickMultipleObjectValues>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldPickMultipleObjectValues): TicketCustomFieldPickMultipleObjectValues {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.TicketCustomFieldObjectValue values */ 1:
                    message.values.push(TicketCustomFieldObjectValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values */ 2:
                    message.allowedValues.push(TicketCustomFieldObjectValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated c1.connector.v2.TicketCustomFieldObjectValue default_values */ 3:
                    message.defaultValues.push(TicketCustomFieldObjectValue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldPickMultipleObjectValues, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.TicketCustomFieldObjectValue values = 1; */
        for (let i = 0; i < message.values.length; i++)
            TicketCustomFieldObjectValue.internalBinaryWrite(message.values[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.TicketCustomFieldObjectValue allowed_values = 2; */
        for (let i = 0; i < message.allowedValues.length; i++)
            TicketCustomFieldObjectValue.internalBinaryWrite(message.allowedValues[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated c1.connector.v2.TicketCustomFieldObjectValue default_values = 3; */
        for (let i = 0; i < message.defaultValues.length; i++)
            TicketCustomFieldObjectValue.internalBinaryWrite(message.defaultValues[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldPickMultipleObjectValues
 */
export const TicketCustomFieldPickMultipleObjectValues = new TicketCustomFieldPickMultipleObjectValues$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketCustomFieldObjectValue$Type extends MessageType<TicketCustomFieldObjectValue> {
    constructor() {
        super("c1.connector.v2.TicketCustomFieldObjectValue", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketCustomFieldObjectValue>): TicketCustomFieldObjectValue {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<TicketCustomFieldObjectValue>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketCustomFieldObjectValue): TicketCustomFieldObjectValue {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketCustomFieldObjectValue, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketCustomFieldObjectValue
 */
export const TicketCustomFieldObjectValue = new TicketCustomFieldObjectValue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketStatus$Type extends MessageType<TicketStatus> {
    constructor() {
        super("c1.connector.v2.TicketStatus", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketStatus>): TicketStatus {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<TicketStatus>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketStatus): TicketStatus {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketStatus, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketStatus
 */
export const TicketStatus = new TicketStatus$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketSchemaRequest$Type extends MessageType<TicketsServiceGetTicketSchemaRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketSchemaRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceGetTicketSchemaRequest>): TicketsServiceGetTicketSchemaRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceGetTicketSchemaRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceGetTicketSchemaRequest): TicketsServiceGetTicketSchemaRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceGetTicketSchemaRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaRequest
 */
export const TicketsServiceGetTicketSchemaRequest = new TicketsServiceGetTicketSchemaRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketSchemaResponse$Type extends MessageType<TicketsServiceGetTicketSchemaResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketSchemaResponse", [
            { no: 1, name: "schema", kind: "message", T: () => TicketSchema },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceGetTicketSchemaResponse>): TicketsServiceGetTicketSchemaResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceGetTicketSchemaResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceGetTicketSchemaResponse): TicketsServiceGetTicketSchemaResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.TicketSchema schema */ 1:
                    message.schema = TicketSchema.internalBinaryRead(reader, reader.uint32(), options, message.schema);
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceGetTicketSchemaResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.TicketSchema schema = 1; */
        if (message.schema)
            TicketSchema.internalBinaryWrite(message.schema, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketSchemaResponse
 */
export const TicketsServiceGetTicketSchemaResponse = new TicketsServiceGetTicketSchemaResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceListTicketSchemasRequest$Type extends MessageType<TicketsServiceListTicketSchemasRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceListTicketSchemasRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 13 /*ScalarType.UINT32*/, options: { "validate.rules": { uint32: { lte: 250, ignoreEmpty: true } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceListTicketSchemasRequest>): TicketsServiceListTicketSchemasRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.pageSize = 0;
        message.pageToken = "";
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceListTicketSchemasRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceListTicketSchemasRequest): TicketsServiceListTicketSchemasRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* uint32 page_size */ 1:
                    message.pageSize = reader.uint32();
                    break;
                case /* string page_token */ 2:
                    message.pageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceListTicketSchemasRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* uint32 page_size = 1; */
        if (message.pageSize !== 0)
            writer.tag(1, WireType.Varint).uint32(message.pageSize);
        /* string page_token = 2; */
        if (message.pageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.pageToken);
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceListTicketSchemasRequest
 */
export const TicketsServiceListTicketSchemasRequest = new TicketsServiceListTicketSchemasRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceListTicketSchemasResponse$Type extends MessageType<TicketsServiceListTicketSchemasResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceListTicketSchemasResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketSchema },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "1", maxBytes: "4096", ignoreEmpty: true } } } },
            { no: 3, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceListTicketSchemasResponse>): TicketsServiceListTicketSchemasResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        message.nextPageToken = "";
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceListTicketSchemasResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceListTicketSchemasResponse): TicketsServiceListTicketSchemasResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.TicketSchema list */ 1:
                    message.list.push(TicketSchema.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string next_page_token */ 2:
                    message.nextPageToken = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 3:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceListTicketSchemasResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.TicketSchema list = 1; */
        for (let i = 0; i < message.list.length; i++)
            TicketSchema.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string next_page_token = 2; */
        if (message.nextPageToken !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.nextPageToken);
        /* repeated google.protobuf.Any annotations = 3; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceListTicketSchemasResponse
 */
export const TicketsServiceListTicketSchemasResponse = new TicketsServiceListTicketSchemasResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Ticket$Type extends MessageType<Ticket> {
    constructor() {
        super("c1.connector.v2.Ticket", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "assignees", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Resource },
            { no: 5, name: "reporter", kind: "message", T: () => Resource },
            { no: 7, name: "status", kind: "message", T: () => TicketStatus },
            { no: 8, name: "type", kind: "message", T: () => TicketType },
            { no: 9, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "url", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "custom_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TicketCustomField } },
            { no: 12, name: "created_at", kind: "message", T: () => Timestamp },
            { no: 13, name: "updated_at", kind: "message", T: () => Timestamp },
            { no: 14, name: "completed_at", kind: "message", T: () => Timestamp },
            { no: 15, name: "requested_for", kind: "message", T: () => Resource }
        ]);
    }
    create(value?: PartialMessage<Ticket>): Ticket {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        message.description = "";
        message.assignees = [];
        message.labels = [];
        message.url = "";
        message.customFields = {};
        if (value !== undefined)
            reflectionMergePartial<Ticket>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Ticket): Ticket {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 3:
                    message.description = reader.string();
                    break;
                case /* repeated c1.connector.v2.Resource assignees */ 4:
                    message.assignees.push(Resource.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* c1.connector.v2.Resource reporter */ 5:
                    message.reporter = Resource.internalBinaryRead(reader, reader.uint32(), options, message.reporter);
                    break;
                case /* c1.connector.v2.TicketStatus status */ 7:
                    message.status = TicketStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* c1.connector.v2.TicketType type */ 8:
                    message.type = TicketType.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                case /* repeated string labels */ 9:
                    message.labels.push(reader.string());
                    break;
                case /* string url */ 10:
                    message.url = reader.string();
                    break;
                case /* map<string, c1.connector.v2.TicketCustomField> custom_fields */ 11:
                    this.binaryReadMap11(message.customFields, reader, options);
                    break;
                case /* google.protobuf.Timestamp created_at */ 12:
                    message.createdAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.createdAt);
                    break;
                case /* google.protobuf.Timestamp updated_at */ 13:
                    message.updatedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.updatedAt);
                    break;
                case /* google.protobuf.Timestamp completed_at */ 14:
                    message.completedAt = Timestamp.internalBinaryRead(reader, reader.uint32(), options, message.completedAt);
                    break;
                case /* c1.connector.v2.Resource requested_for */ 15:
                    message.requestedFor = Resource.internalBinaryRead(reader, reader.uint32(), options, message.requestedFor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap11(map: Ticket["customFields"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof Ticket["customFields"] | undefined, val: Ticket["customFields"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TicketCustomField.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.connector.v2.Ticket.custom_fields");
            }
        }
        map[key ?? ""] = val ?? TicketCustomField.create();
    }
    internalBinaryWrite(message: Ticket, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        /* string description = 3; */
        if (message.description !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.description);
        /* repeated c1.connector.v2.Resource assignees = 4; */
        for (let i = 0; i < message.assignees.length; i++)
            Resource.internalBinaryWrite(message.assignees[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.Resource reporter = 5; */
        if (message.reporter)
            Resource.internalBinaryWrite(message.reporter, writer.tag(5, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketStatus status = 7; */
        if (message.status)
            TicketStatus.internalBinaryWrite(message.status, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketType type = 8; */
        if (message.type)
            TicketType.internalBinaryWrite(message.type, writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        /* repeated string labels = 9; */
        for (let i = 0; i < message.labels.length; i++)
            writer.tag(9, WireType.LengthDelimited).string(message.labels[i]);
        /* string url = 10; */
        if (message.url !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.url);
        /* map<string, c1.connector.v2.TicketCustomField> custom_fields = 11; */
        for (let k of globalThis.Object.keys(message.customFields)) {
            writer.tag(11, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TicketCustomField.internalBinaryWrite(message.customFields[k], writer, options);
            writer.join().join();
        }
        /* google.protobuf.Timestamp created_at = 12; */
        if (message.createdAt)
            Timestamp.internalBinaryWrite(message.createdAt, writer.tag(12, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp updated_at = 13; */
        if (message.updatedAt)
            Timestamp.internalBinaryWrite(message.updatedAt, writer.tag(13, WireType.LengthDelimited).fork(), options).join();
        /* google.protobuf.Timestamp completed_at = 14; */
        if (message.completedAt)
            Timestamp.internalBinaryWrite(message.completedAt, writer.tag(14, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.Resource requested_for = 15; */
        if (message.requestedFor)
            Resource.internalBinaryWrite(message.requestedFor, writer.tag(15, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.Ticket
 */
export const Ticket = new Ticket$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketType$Type extends MessageType<TicketType> {
    constructor() {
        super("c1.connector.v2.TicketType", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketType>): TicketType {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.displayName = "";
        if (value !== undefined)
            reflectionMergePartial<TicketType>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketType): TicketType {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* string display_name */ 2:
                    message.displayName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketType, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* string display_name = 2; */
        if (message.displayName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.displayName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketType
 */
export const TicketType = new TicketType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketRequest$Type extends MessageType<TicketRequest> {
    constructor() {
        super("c1.connector.v2.TicketRequest", [
            { no: 1, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "message", T: () => TicketStatus },
            { no: 4, name: "type", kind: "message", T: () => TicketType },
            { no: 5, name: "labels", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "custom_fields", kind: "map", K: 9 /*ScalarType.STRING*/, V: { kind: "message", T: () => TicketCustomField } },
            { no: 7, name: "requested_for", kind: "message", T: () => Resource }
        ]);
    }
    create(value?: PartialMessage<TicketRequest>): TicketRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.displayName = "";
        message.description = "";
        message.labels = [];
        message.customFields = {};
        if (value !== undefined)
            reflectionMergePartial<TicketRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketRequest): TicketRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string display_name */ 1:
                    message.displayName = reader.string();
                    break;
                case /* string description */ 2:
                    message.description = reader.string();
                    break;
                case /* c1.connector.v2.TicketStatus status */ 3:
                    message.status = TicketStatus.internalBinaryRead(reader, reader.uint32(), options, message.status);
                    break;
                case /* c1.connector.v2.TicketType type */ 4:
                    message.type = TicketType.internalBinaryRead(reader, reader.uint32(), options, message.type);
                    break;
                case /* repeated string labels */ 5:
                    message.labels.push(reader.string());
                    break;
                case /* map<string, c1.connector.v2.TicketCustomField> custom_fields */ 6:
                    this.binaryReadMap6(message.customFields, reader, options);
                    break;
                case /* c1.connector.v2.Resource requested_for */ 7:
                    message.requestedFor = Resource.internalBinaryRead(reader, reader.uint32(), options, message.requestedFor);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    private binaryReadMap6(map: TicketRequest["customFields"], reader: IBinaryReader, options: BinaryReadOptions): void {
        let len = reader.uint32(), end = reader.pos + len, key: keyof TicketRequest["customFields"] | undefined, val: TicketRequest["customFields"][any] | undefined;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case 1:
                    key = reader.string();
                    break;
                case 2:
                    val = TicketCustomField.internalBinaryRead(reader, reader.uint32(), options);
                    break;
                default: throw new globalThis.Error("unknown map entry field for c1.connector.v2.TicketRequest.custom_fields");
            }
        }
        map[key ?? ""] = val ?? TicketCustomField.create();
    }
    internalBinaryWrite(message: TicketRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string display_name = 1; */
        if (message.displayName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.displayName);
        /* string description = 2; */
        if (message.description !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.description);
        /* c1.connector.v2.TicketStatus status = 3; */
        if (message.status)
            TicketStatus.internalBinaryWrite(message.status, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketType type = 4; */
        if (message.type)
            TicketType.internalBinaryWrite(message.type, writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        /* repeated string labels = 5; */
        for (let i = 0; i < message.labels.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.labels[i]);
        /* map<string, c1.connector.v2.TicketCustomField> custom_fields = 6; */
        for (let k of globalThis.Object.keys(message.customFields)) {
            writer.tag(6, WireType.LengthDelimited).fork().tag(1, WireType.LengthDelimited).string(k);
            writer.tag(2, WireType.LengthDelimited).fork();
            TicketCustomField.internalBinaryWrite(message.customFields[k], writer, options);
            writer.join().join();
        }
        /* c1.connector.v2.Resource requested_for = 7; */
        if (message.requestedFor)
            Resource.internalBinaryWrite(message.requestedFor, writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketRequest
 */
export const TicketRequest = new TicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceCreateTicketRequest$Type extends MessageType<TicketsServiceCreateTicketRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceCreateTicketRequest", [
            { no: 1, name: "request", kind: "message", T: () => TicketRequest },
            { no: 2, name: "schema", kind: "message", T: () => TicketSchema },
            { no: 8, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceCreateTicketRequest>): TicketsServiceCreateTicketRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceCreateTicketRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceCreateTicketRequest): TicketsServiceCreateTicketRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.TicketRequest request */ 1:
                    message.request = TicketRequest.internalBinaryRead(reader, reader.uint32(), options, message.request);
                    break;
                case /* c1.connector.v2.TicketSchema schema */ 2:
                    message.schema = TicketSchema.internalBinaryRead(reader, reader.uint32(), options, message.schema);
                    break;
                case /* repeated google.protobuf.Any annotations */ 8:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceCreateTicketRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.TicketRequest request = 1; */
        if (message.request)
            TicketRequest.internalBinaryWrite(message.request, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* c1.connector.v2.TicketSchema schema = 2; */
        if (message.schema)
            TicketSchema.internalBinaryWrite(message.schema, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 8; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(8, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceCreateTicketRequest
 */
export const TicketsServiceCreateTicketRequest = new TicketsServiceCreateTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceCreateTicketResponse$Type extends MessageType<TicketsServiceCreateTicketResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceCreateTicketResponse", [
            { no: 1, name: "ticket", kind: "message", T: () => Ticket },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceCreateTicketResponse>): TicketsServiceCreateTicketResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceCreateTicketResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceCreateTicketResponse): TicketsServiceCreateTicketResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Ticket ticket */ 1:
                    message.ticket = Ticket.internalBinaryRead(reader, reader.uint32(), options, message.ticket);
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string error */ 3:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceCreateTicketResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Ticket ticket = 1; */
        if (message.ticket)
            Ticket.internalBinaryWrite(message.ticket, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string error = 3; */
        if (message.error !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceCreateTicketResponse
 */
export const TicketsServiceCreateTicketResponse = new TicketsServiceCreateTicketResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketRequest$Type extends MessageType<TicketsServiceGetTicketRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketRequest", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceGetTicketRequest>): TicketsServiceGetTicketRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.id = "";
        message.annotations = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceGetTicketRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceGetTicketRequest): TicketsServiceGetTicketRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string id */ 1:
                    message.id = reader.string();
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceGetTicketRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string id = 1; */
        if (message.id !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.id);
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketRequest
 */
export const TicketsServiceGetTicketRequest = new TicketsServiceGetTicketRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceGetTicketResponse$Type extends MessageType<TicketsServiceGetTicketResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceGetTicketResponse", [
            { no: 1, name: "ticket", kind: "message", T: () => Ticket },
            { no: 2, name: "annotations", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "error", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceGetTicketResponse>): TicketsServiceGetTicketResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.annotations = [];
        message.error = "";
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceGetTicketResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceGetTicketResponse): TicketsServiceGetTicketResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.connector.v2.Ticket ticket */ 1:
                    message.ticket = Ticket.internalBinaryRead(reader, reader.uint32(), options, message.ticket);
                    break;
                case /* repeated google.protobuf.Any annotations */ 2:
                    message.annotations.push(Any.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* string error */ 3:
                    message.error = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceGetTicketResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.connector.v2.Ticket ticket = 1; */
        if (message.ticket)
            Ticket.internalBinaryWrite(message.ticket, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated google.protobuf.Any annotations = 2; */
        for (let i = 0; i < message.annotations.length; i++)
            Any.internalBinaryWrite(message.annotations[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string error = 3; */
        if (message.error !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.error);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceGetTicketResponse
 */
export const TicketsServiceGetTicketResponse = new TicketsServiceGetTicketResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkCreateTicketsRequest$Type extends MessageType<TicketsServiceBulkCreateTicketsRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkCreateTicketsRequest", [
            { no: 1, name: "ticket_requests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceCreateTicketRequest }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceBulkCreateTicketsRequest>): TicketsServiceBulkCreateTicketsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ticketRequests = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceBulkCreateTicketsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceBulkCreateTicketsRequest): TicketsServiceBulkCreateTicketsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.TicketsServiceCreateTicketRequest ticket_requests */ 1:
                    message.ticketRequests.push(TicketsServiceCreateTicketRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceBulkCreateTicketsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.TicketsServiceCreateTicketRequest ticket_requests = 1; */
        for (let i = 0; i < message.ticketRequests.length; i++)
            TicketsServiceCreateTicketRequest.internalBinaryWrite(message.ticketRequests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsRequest
 */
export const TicketsServiceBulkCreateTicketsRequest = new TicketsServiceBulkCreateTicketsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkCreateTicketsResponse$Type extends MessageType<TicketsServiceBulkCreateTicketsResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkCreateTicketsResponse", [
            { no: 1, name: "tickets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceCreateTicketResponse }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceBulkCreateTicketsResponse>): TicketsServiceBulkCreateTicketsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tickets = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceBulkCreateTicketsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceBulkCreateTicketsResponse): TicketsServiceBulkCreateTicketsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.TicketsServiceCreateTicketResponse tickets */ 1:
                    message.tickets.push(TicketsServiceCreateTicketResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceBulkCreateTicketsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.TicketsServiceCreateTicketResponse tickets = 1; */
        for (let i = 0; i < message.tickets.length; i++)
            TicketsServiceCreateTicketResponse.internalBinaryWrite(message.tickets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkCreateTicketsResponse
 */
export const TicketsServiceBulkCreateTicketsResponse = new TicketsServiceBulkCreateTicketsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkGetTicketsRequest$Type extends MessageType<TicketsServiceBulkGetTicketsRequest> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkGetTicketsRequest", [
            { no: 1, name: "ticket_requests", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceGetTicketRequest }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceBulkGetTicketsRequest>): TicketsServiceBulkGetTicketsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.ticketRequests = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceBulkGetTicketsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceBulkGetTicketsRequest): TicketsServiceBulkGetTicketsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.TicketsServiceGetTicketRequest ticket_requests */ 1:
                    message.ticketRequests.push(TicketsServiceGetTicketRequest.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceBulkGetTicketsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.TicketsServiceGetTicketRequest ticket_requests = 1; */
        for (let i = 0; i < message.ticketRequests.length; i++)
            TicketsServiceGetTicketRequest.internalBinaryWrite(message.ticketRequests[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsRequest
 */
export const TicketsServiceBulkGetTicketsRequest = new TicketsServiceBulkGetTicketsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TicketsServiceBulkGetTicketsResponse$Type extends MessageType<TicketsServiceBulkGetTicketsResponse> {
    constructor() {
        super("c1.connector.v2.TicketsServiceBulkGetTicketsResponse", [
            { no: 1, name: "tickets", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TicketsServiceGetTicketResponse }
        ]);
    }
    create(value?: PartialMessage<TicketsServiceBulkGetTicketsResponse>): TicketsServiceBulkGetTicketsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.tickets = [];
        if (value !== undefined)
            reflectionMergePartial<TicketsServiceBulkGetTicketsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: TicketsServiceBulkGetTicketsResponse): TicketsServiceBulkGetTicketsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.connector.v2.TicketsServiceGetTicketResponse tickets */ 1:
                    message.tickets.push(TicketsServiceGetTicketResponse.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: TicketsServiceBulkGetTicketsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.connector.v2.TicketsServiceGetTicketResponse tickets = 1; */
        for (let i = 0; i < message.tickets.length; i++)
            TicketsServiceGetTicketResponse.internalBinaryWrite(message.tickets[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.connector.v2.TicketsServiceBulkGetTicketsResponse
 */
export const TicketsServiceBulkGetTicketsResponse = new TicketsServiceBulkGetTicketsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.connector.v2.TicketsService
 */
export const TicketsService = new ServiceType("c1.connector.v2.TicketsService", [
    { name: "CreateTicket", options: {}, I: TicketsServiceCreateTicketRequest, O: TicketsServiceCreateTicketResponse },
    { name: "GetTicket", options: {}, I: TicketsServiceGetTicketRequest, O: TicketsServiceGetTicketResponse },
    { name: "ListTicketSchemas", options: {}, I: TicketsServiceListTicketSchemasRequest, O: TicketsServiceListTicketSchemasResponse },
    { name: "GetTicketSchema", options: {}, I: TicketsServiceGetTicketSchemaRequest, O: TicketsServiceGetTicketSchemaResponse },
    { name: "BulkCreateTickets", options: {}, I: TicketsServiceBulkCreateTicketsRequest, O: TicketsServiceBulkCreateTicketsResponse },
    { name: "BulkGetTickets", options: {}, I: TicketsServiceBulkGetTicketsRequest, O: TicketsServiceBulkGetTicketsResponse }
]);
